import { render, staticRenderFns } from "./MoleculeTheHeaderLicenseUpgrade.vue?vue&type=template&id=a0246970&"
import script from "./MoleculeTheHeaderLicenseUpgrade.vue?vue&type=script&lang=js&"
export * from "./MoleculeTheHeaderLicenseUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports